@let layout = layout$ | async;

<render-layout
  *ngIf="layout"
  [layout]="layout">
</render-layout>
<render-svg-sprite hidden></render-svg-sprite>
